(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-video-hero')) {
    customElements.define('mc-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.mc-video-hero__toggle');
        const headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
        this.headerObserver = new ResizeObserver(() => {
          const height = headers.reduce((total, element) => total + element.getBoundingClientRect().height, 0);
          this.style.setProperty('--mc-header-stack', height + 'px');
        });
        headers.forEach(element => this.headerObserver.observe(element));
        if (!this.video || !this.toggle) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.visible = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = !this.motion.matches && !navigator.connection?.saveData;
        this.toggle.hidden = false;
        const syncButton = () => {
          this.toggle.dataset.paused = String(this.video.paused);
          this.toggle.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        };
        const updatePlayback = () => {
          if (this.wantsPlayback && this.visible && !document.hidden) {
            this.video.play().catch(() => { this.wantsPlayback = false; syncButton(); });
          } else {
            this.video.pause();
          }
        };
        this.toggle.addEventListener('click', () => {
          this.wantsPlayback = this.video.paused;
          updatePlayback();
        }, { signal });
        this.video.addEventListener('playing', syncButton, { signal });
        this.video.addEventListener('pause', syncButton, { signal });
        this.video.addEventListener('error', () => { this.toggle.hidden = true; }, { signal });
        document.addEventListener('visibilitychange', updatePlayback, { signal });
        this.motion.addEventListener('change', event => {
          this.wantsPlayback = !event.matches && !navigator.connection?.saveData;
          updatePlayback();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          updatePlayback();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        syncButton();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.headerObserver?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
